import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
// Corrected path from '../firebase' to '../../firebase'
import { db } from '../../firebase'; 
import { collection, query, where, getDocs, limit } from 'firebase/firestore';
import { Loader2 } from 'lucide-react';

export default function ArticlePage() {
    const { slug } = useParams();
    const [article, setArticle] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchArticle = async () => {
            setError('');
            setLoading(true);
            const q = query(
                collection(db, 'learning_articles'), 
                where('slug', '==', slug),
                where('published', '==', true),
                limit(1)
            );

            const querySnapshot = await getDocs(q);
            if (querySnapshot.empty) {
                setError('Article not found.');
            } else {
                setArticle(querySnapshot.docs[0].data());
            }
            setLoading(false);
        };
        fetchArticle();
    }, [slug]);

    if (loading) {
        return <div className="flex justify-center items-center h-64"><Loader2 className="animate-spin text-cyan-400" size={48} /></div>;
    }
    if (error) {
        return <p className="text-center text-red-400 p-8">{error}</p>;
    }

    return (
        <div className="glass-card rounded-2xl p-8 lg:p-12">
            <h1 className="text-4xl font-bold text-white mb-6">{article.title}</h1>
            <div 
                className="prose prose-invert prose-lg max-w-none" 
                dangerouslySetInnerHTML={{ __html: article.content }} 
            />
             <div className="text-center pt-8 mt-8 border-t border-white/10">
                <Link to="/learn" className="text-cyan-400 hover:text-cyan-300 font-semibold">
                    &larr; Back to All Learning Guides
                </Link>
            </div>
        </div>
    )
}